import { type ReferenceMeasurementState } from '@/api/generator';
import { NotificationMessage } from '@/components/notifications/types.ts';
import { TFunction } from 'i18next';

export function useReferenceMeasurementInfo(t: TFunction) {
  function getNotification(
    referenceMeasurementState?: ReferenceMeasurementState,
  ): NotificationMessage | undefined {
    const notificationDefaults = {
      type: 'warning',
      closable: false,
    } as const;

    switch (referenceMeasurementState) {
      case undefined:
      case 'Undefined':
        return {
          ...notificationDefaults,
          message: t('ReferenceMeasurementMissing'),
        };
      case 'CalibrationMissing':
        return {
          ...notificationDefaults,
          message: t('ReferenceMeasurementCalibrationMissing'),
        };
      case 'Outdated':
        return {
          ...notificationDefaults,
          message: t('ReferenceMeasurementOutdated'),
        };
      default:
        return undefined;
    }
  }
  return { getNotification };
}
